<div class="form-group">
    <div class="form-row">
        <div class="confirm-message" [innerHTML]="_message"></div>
    </div>
</div>
<div
    class="form-group form-group--buttons"
    [class.form-group--buttons-left]="_options.buttonsOnLeft"
>
    <div class="form-row">
        @for (button of _options.buttons; track button) {
            <lg-button
                [buttonClass]="button.class"
                [text]="button.name"
                [icon]="button.icon"
                (click)="_buttonClick(button)"
            >
            </lg-button>
        }
    </div>
</div>
